export default {
      id: "plate_blur-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#plate_blur",
      toString: function () {
        return this.url;
      }
    }